var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { PlayIcon } from '@heroicons/react/20/solid';
import { Translate } from "../../../I18N";











const verifyUrl = (url) => {
  if (!ReactPlayer.canPlay(url)) {
    return 'invalid';
  }

  if (url.startsWith('https') || url.startsWith('http')) {
    return 'embedded';
  }

  return 'internal';
};

const ThumbnailOverlay = ({ thumbnail }) => {
  const overlayBackgroundStyle = thumbnail !== null && thumbnail !== void 0 && thumbnail.url ?
  {
    backgroundImage: `url("${thumbnail.url}")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  } :
  { background: 'linear-gradient(180deg, rgba(0,0,0,0.4) 6%, rgba(156,163,175,0.6) 50%)' };

  const mediaTitleStyle = thumbnail !== null && thumbnail !== void 0 && thumbnail.url ? 'text-gray-100' : '';

  return (/*#__PURE__*/
    _jsx("div", { className: "relative w-full h-full", style: overlayBackgroundStyle }, void 0, /*#__PURE__*/
    _jsx("p", {
      className: `overflow-hidden p-4 font-normal text-left overflow-ellipsis whitespace-nowrap opacity-1 ${mediaTitleStyle}` }, void 0,

    thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.fileName
    )
    ));

};

const MediaPlayer = ({ url, width, height, thumbnail }) => {
  const [playing, setPlaying] = useState(false);
  const [playerHeight, setPlayerHeight] = useState(0);
  const containerRef = useRef(null);

  const mediaType = verifyUrl(url);

  const playIconColor = thumbnail !== null && thumbnail !== void 0 && thumbnail.url ?
  'text-gray-100 hover:text-white' :
  'text-gray-500 hover:text-gray-700';

  const renderThumbnail =
  mediaType === 'internal' ? /*#__PURE__*/_jsx(ThumbnailOverlay, { thumbnail: thumbnail }) : false;

  useEffect(() => {var _containerRef$current;
    if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.clientHeight) {
      setPlayerHeight(containerRef.current.clientHeight);
    }
  }, []);

  return (/*#__PURE__*/
    React.createElement("div", {
      style: { width: width || '100%', height: height || '100%' },
      className: "relative",
      ref: containerRef },

    mediaType === 'invalid' && /*#__PURE__*/
    _jsx("div", { className: "flex absolute top-0 left-0 justify-center items-center p-4 w-full h-full bg-gray-50 rounded border" }, void 0, /*#__PURE__*/
    _jsx("p", { className: "text-center" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "This file type is not supported on media fields")
    )
    ),


    mediaType !== 'invalid' && playerHeight ? /*#__PURE__*/
    _jsx(ReactPlayer, {
      className: "absolute top-0 left-0",
      width: "100%",
      height: "100%",
      controls: true,
      url: url,
      playing: playing,
      light: renderThumbnail,
      config: {
        facebook: {
          attributes: {
            'data-height': playerHeight
          }
        }
      },
      playIcon: /*#__PURE__*/
      _jsx(PlayIcon, { className: `absolute w-1/5 min-w-[20px] max-w-[120px] ${playIconColor}` }),

      onClickPreview: () => !playing && setPlaying(true) }
    ) : /*#__PURE__*/

    _jsx("div", {})

    ));

};

export { MediaPlayer };